import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchGetQuery, fetchPutQuery } from "../api";

//API call GET sifrant statusov projekta (za dropdown v modalu)
export function useGetSifrantStatusovProjekta() {
  const url = `sifrant/status`;
  return useQuery({
    queryKey: ["status-options"],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//API call GET to get validation fields for project status change
export function useGetStatusValidationFieldsForProject(idProjekt, idStatus) {
  const url = `projekti/${idProjekt}/statusV2/${idStatus}`;
  return useQuery({
    queryKey: ["status-validation-fields", idProjekt, idStatus],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    enabled: !!idProjekt && !!idStatus, // query will run only if both idProjekt and idStatus are available
  });
}

//PUT change project status
export function useChangeProjectStatus(idProjekt, idStatus) {
  const queryClient = useQueryClient();
  const url = `projekti/${idProjekt}/status/${idStatus}`;
  return useMutation({
    mutationFn: async (data) => {
      return fetchPutQuery(url, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["project-status-naziv", idProjekt]);
    },
  });
}
//API call PUT to update project status
